<template>
  <div class="ship-units search-ship-container">
    <h4 class="integrated-shipment-headers">
      Search Orders
    </h4>

    <form @submit.prevent="onSubmit">
      <station
        @stationChanged="changeStation"
        :stations="JSON.parse(data)"
        :selectedStation="selectedStation"
      ></station>
      <div v-if="holds && holds.special_items" class="shipment-date-container">
        <span>Early Pickup Date: {{holds && holds.special_items && holds.special_items.formatted_ship_date}}</span>
        <span>Late Delivery Date: {{holds && holds.special_items && holds.special_items.formatted_deliver_by_date}}</span>
      </div>
      <label class="order-form">
        Delivery:
        <div v-for="(orderNumber, index) in orderNumbers" :key="index" required>
          <input v-model="orderNumber.number" />
          <span class="hold" v-if="holding(orderNumber)">HOLD</span>
          <span class="hold" v-if="consolidate(orderNumber)">CONSOLIDATE</span>
          <span
            v-if="orderNumbers.length > 1"
            @click="removeOrderNumber(index)"
            class="icon-remove"
          ></span>
        </div>
      </label>
      <div class="btn-container">
        <button class="btn btn-primary" type="submit">
          Find
          <font-awesome-icon v-if="loading" icon="circle-notch" spin class="loading-spinner" />
        </button>
        <button  v-if="canTestRequest" class="btn btn-primary admin-only" @click.prevent="testOrderResponse">Test Response</button>
        <button class="btn btn-primary" @click.prevent="addOrderNumber">Add Delivery</button>
        <button class="btn btn-primary" @click.prevent="getConsolidatedOrders">
          Consolidation
          <font-awesome-icon
            v-if="loadingConsolidated"
            icon="circle-notch"
            spin
            class="loading-spinner"
          />
        </button>
      </div>
      <div class="saved-deliveries-container">
        <button class="btn btn-primary" @click.prevent="toggleLoadShipmentModal">Saved Deliveries</button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      selectedStation: this.stationId
    };
  },
  props: [
    "data",
    "loading",
    "stationId",
    "holds",
    "loadingConsolidated",
    "orderNumbers",
    "canTest"
  ],
  computed: {
    canTestRequest: function() {
      return this.$props.canTest == true;
    }
  },
  methods: {
    onSubmit() {
      this.$emit(
        "orderNumberSubmitted",
        this.orderNumbers,
        this.selectedStation
      );
    },
    testOrderResponse() {
      this.$emit(
        "testOrderResponse",
        this.orderNumbers,
        this.selectedStation
      );
    },
    toggleLoadShipmentModal(){
      this.$emit("toggleLoadShipmentModal");
    },
    getConsolidatedOrders() {
      this.$emit("getConsolidatedOrders");
    },
    holding(orderNumber) {
      if (orderNumber.number && this.$props.holds) {
        return this.$props.holds.special_items.hold_ship && this.$props.holds.special_items.hold_ship.find(
          hold =>
            hold.order_number.toLowerCase() === orderNumber.number.toLowerCase()
        );
      }
    },
    consolidate(orderNumber) {
      if (orderNumber.number && this.$props.holds) {
        return this.$props.holds.special_items.consolidate && this.$props.holds.special_items.consolidate.find(
          order =>
            order.order_number.toLowerCase() ===
            orderNumber.number.toLowerCase()
        );
      }
    },
    addOrderNumber(index) {
      this.orderNumbers.push({ number: null });
    },
    removeOrderNumber(index) {
      this.orderNumbers.splice(index, 1);
      if (this.orderNumbers.length > 0) {
        this.onSubmit();
      }
    },
    changeStation(stationId) {
      this.selectedStation = stationId;
    }
  }
};
</script>

<style scoped>
.search-ship-container {
  width: 33%;
  box-sizing: border-box;
  height: 337px;
}

.shipment-date-container {
  display: flex;
  justify-content: space-between;
  border: 1px solid lightgrey;
}

.shipment-date-container span {
  width: 50%;
  font-size: 10px;
  text-align: center;
}

.shipment-date-container span:first-of-type {
  border-right: 1px solid black;
}

form {
  padding: 5px 10px;
}

label.order-form {
  display: block;
  margin-bottom: 5px;
  overflow: auto;
  height: 99px;
  outline: solid 0.5px #ccc;
  padding: 10px;
}

label > div {
  padding-top: 10px;
  display: flex;
  align-items: center;
}

.hold {
  margin-right: 0.5rem;
  font-weight: bold;
}

.order-form input {
  width: 70%;
  margin-right: 0.5rem;
}

p {
  font-size: 5rem;
  text-align: center;
}

.saved-deliveries-container{
    display: flex;
    justify-content: center;
    font-size: 6px;
}

.saved-deliveries-container button.btn{
  width: 34%;
}

.btn-container {
  display: flex;
  justify-content: space-between;
}

button.btn {
  width: 33%;
  min-height: 30px;
  border-radius: 50px;
  margin-top: 7px;
}

.integrated-shipment-headers button {
  margin-top: 0;
}
</style>
